import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

const obtenerCampoRazon = (monitoreo) =>
  monitoreo.comentarioHistorial || "";

const obtenerRazonDevolucion = (monitoreo = {}) => {
  const comentarioHistorial = obtenerCampoRazon(monitoreo);

  return comentarioHistorial.toLowerCase().includes("fue devuelto")
    ? comentarioHistorial
    : "";
};

export const ModalNotaDevolucion = (props) => {
  const { modalNotaDevolucion, monitoreo } = props;
  const razonDevolucion = obtenerRazonDevolucion(monitoreo);

  const toggle = () => {
    props.activarModalNotaDevolucion();
  };

  return (
    <Modal isOpen={modalNotaDevolucion} toggle={toggle} size="lg" backdrop="static">
      <ModalHeader className="block-example border-bottom" toggle={toggle}>
        Razon Devolucion Monitoreo
      </ModalHeader>

      <ModalBody>
        <div className="text-left my-4">
          <h5>{razonDevolucion}</h5>
        </div>
      </ModalBody>

      <ModalFooter>
        <button
          className="btn btn-info btn-sm"
          onClick={(e) => {
            e.preventDefault();
            toggle();
          }}
        >
          Cerrar
        </button>
      </ModalFooter>
    </Modal>
  );
};
